import {AUTHENTICATION_CONSTANTS} from "../constants/authentication-constants";

const AUTHENTICATION_ACTIONS = {
    setUserToken(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.SET_USER_TOKEN,
            data,
        };
    },
    setStreamID(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.SET_STREAM_ID,
            data,
        };
    },

    setUserLogOut(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.SET_USER_LOGOUT,
            data,
        };

    },
    navigateToHomepage(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.NAVIGATE_TO_HOMEPAGE,
            data,
        };

    },
    setUserWallets(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.SET_USER_WALLETS,
            data,
        };

    },

    setNetworkSettings(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.SET_NETWORK_SETTINGS,
            data,
        };

    },

    setCurrenciesAction(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.SET_CURRENCIES,
            data,
        };

    },
    setActiveWallet(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.SET_ACTIVE_WALLET,
            data,
        };

    },
    updateWalletBalance(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.SET_WALLET_BALANCE,
            data,
        };

    },
    updateUserPercentage(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.SET_WALLET_PERCENTAGE,
            data,
        };

    },
    setActiveNetwork(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.SET_ACTIVE_NETWORK,
            data,
        };

    },


    setDisplayFiatInCryptoAction(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.SET_DISPLAY_FIAT_IN_CRYPTO,
            data,
        };

    },


    setSelectedFiatAction(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.SET_SELECTED_FIAT,
            data,
        };

    },

    setFiatRatesAction(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.SET_FIAT_RATES,
            data,
        };

    },


    setIgnoredUsers(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.SET_IGNORED_USERS,
            data,
        };

    },


    setHideZeroBalancesAction(data) {
        return {
            type: AUTHENTICATION_CONSTANTS.SET_HIDE_ZERO_BALANCE,
            data,
        };


        // AUTHENTICATION_CONSTANTS.SET_DISPLAY_FIAT_IN_CRYPTO
    }
}


export default AUTHENTICATION_ACTIONS
